var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSameDayDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 37C2 24.0786 2 17.618 5.13166 12.9944C6.42888 11.0793 8.07926 9.42888 9.99445 8.13166C14.618 5 21.0786 5 34 5V5C46.9214 5 53.382 5 58.0055 8.13166C59.9207 9.42888 61.5711 11.0793 62.8683 12.9944C66 17.618 66 24.0786 66 37V37C66 49.9214 66 56.382 62.8683 61.0055C61.5711 62.9207 59.9207 64.5711 58.0055 65.8683C53.382 69 46.9214 69 34 69V69C21.0786 69 14.618 69 9.99445 65.8683C8.07926 64.5711 6.42888 62.9207 5.13166 61.0055C2 56.382 2 49.9214 2 37V37Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iif)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6062 37.3595C56.6062 49.6463 46.6459 59.6067 34.3592 59.6067C22.0726 59.6067 12.1123 49.6463 12.1123 37.3595C12.1123 25.0727 22.0726 15.1123 34.3592 15.1123C46.6459 15.1123 56.6062 25.0727 56.6062 37.3595Z",
    fill: "url(#paint1_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3169 9.00195C14.3169 8.17353 14.9885 7.50195 15.8169 7.50195H52.8169C53.6453 7.50195 54.3169 8.17353 54.3169 9.00195V9.00195C54.3169 9.83038 53.6453 10.502 52.8169 10.502H15.8169C14.9885 10.502 14.3169 9.83038 14.3169 9.00195V9.00195Z",
    fill: "#FAFAFA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6919 56.875C62.2777 56.875 61.9419 56.5392 61.9419 56.125V17.625C61.9419 17.2108 62.2777 16.875 62.6919 16.875V16.875C63.1061 16.875 63.4419 17.2108 63.4419 17.625V56.125C63.4419 56.5392 63.1061 56.875 62.6919 56.875V56.875Z",
    fill: "#F8F8F8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.56689 56.875C5.35979 56.875 5.19189 56.7071 5.19189 56.5L5.19189 17.25C5.19189 17.0429 5.35979 16.875 5.56689 16.875V16.875C5.774 16.875 5.94189 17.0429 5.94189 17.25L5.94189 56.5C5.94189 56.7071 5.774 56.875 5.56689 56.875V56.875Z",
    fill: "#F8F8F8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4459 23.2021C6.21606 23.2021 6.03274 23.0434 6.04556 22.8512C6.12738 21.624 6.50597 17.4884 7.97626 15.4359C9.58739 13.1867 13.1893 11.3544 13.7084 11.098C13.751 11.077 13.7972 11.0673 13.8467 11.0673V11.0673C14.1041 11.0673 14.2323 11.3311 14.0475 11.4811C12.9713 12.3538 10.4745 14.4256 9.13525 15.9212C7.64728 17.583 7.00828 21.7339 6.85502 22.8957C6.83193 23.0707 6.65618 23.2021 6.4459 23.2021V23.2021Z",
    fill: "#FAFAFA"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6665 23.708C61.867 23.708 62.027 23.5427 62.0158 23.3424C61.9444 22.0641 61.6141 17.7562 60.3312 15.6181C58.9255 13.2753 55.7828 11.3666 55.3298 11.0995C55.2927 11.0776 55.2523 11.0676 55.2092 11.0676V11.0676C54.9846 11.0676 54.8727 11.3424 55.034 11.4985C55.973 12.4076 58.1515 14.5657 59.32 16.1237C60.6183 17.8548 61.1758 22.1786 61.3095 23.3888C61.3297 23.5711 61.483 23.708 61.6665 23.708V23.708Z",
    fill: "#FAFAFA"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16525 16.5202C8.11128 16.4996 8.08436 16.4394 8.10612 16.3859C8.2138 16.121 8.53818 15.3617 8.96923 14.7079C9.43402 14.0029 10.1114 13.5718 10.2754 13.474C10.2986 13.4601 10.3267 13.4582 10.3519 13.4678V13.4678C10.4194 13.4936 10.4329 13.584 10.3761 13.6287C10.1107 13.8377 9.5071 14.334 9.16466 14.7825C8.79389 15.2681 8.41915 16.1659 8.30102 16.4608C8.27955 16.5145 8.21921 16.5408 8.16525 16.5202V16.5202Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8919 16.5202C59.9458 16.4996 59.9728 16.4394 59.951 16.3859C59.8433 16.121 59.5189 15.3617 59.0879 14.7079C58.6231 14.0029 57.9457 13.5718 57.7818 13.474C57.7586 13.4601 57.7305 13.4582 57.7052 13.4678V13.4678C57.6377 13.4936 57.6242 13.584 57.681 13.6287C57.9464 13.8377 58.55 14.334 58.8925 14.7825C59.2632 15.2681 59.638 16.1659 59.7561 16.4608C59.7776 16.5145 59.8379 16.5408 59.8919 16.5202V16.5202Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5559 29.3992C26.6906 29.3992 25.8641 29.7382 25.2572 30.3366C24.6508 30.9344 24.3133 31.7416 24.3133 32.5798V42.3387C24.3133 43.1769 24.6508 43.9842 25.2572 44.582C25.8641 45.1803 26.6906 45.5193 27.5559 45.5193H30.8553C31.4941 45.5193 32.0119 46.0372 32.0119 46.676C32.0119 47.3148 31.4941 47.8326 30.8553 47.8326H27.5559C26.0876 47.8326 24.6762 47.2577 23.6331 46.2293C22.5894 45.2003 22 43.8011 22 42.3387V32.5798C22 31.1174 22.5894 29.7183 23.6331 28.6893C24.6762 27.6608 26.0876 27.0859 27.5559 27.0859H39.6538C41.122 27.0859 42.5334 27.6608 43.5765 28.6893C44.6202 29.7183 45.2096 31.1174 45.2096 32.5798V35.8328C45.2096 36.4716 44.6918 36.9894 44.053 36.9894C43.4142 36.9894 42.8964 36.4716 42.8964 35.8328V32.5798C42.8964 31.7416 42.5588 30.9344 41.9524 30.3366C41.3456 29.7382 40.519 29.3992 39.6538 29.3992H27.5559Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7553 26C30.3941 26 30.9119 26.5178 30.9119 27.1566V29.3253C30.9119 29.9641 30.3941 30.4819 29.7553 30.4819C29.1165 30.4819 28.5986 29.9641 28.5986 29.3253V27.1566C28.5986 26.5178 29.1165 26 29.7553 26Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4545 26C38.0933 26 38.6111 26.5178 38.6111 27.1566V29.3253C38.6111 29.9641 38.0933 30.4819 37.4545 30.4819C36.8157 30.4819 36.2979 29.9641 36.2979 29.3253V27.1566C36.2979 26.5178 36.8157 26 37.4545 26Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 33.6625C22 33.0237 22.5178 32.5059 23.1566 32.5059H44.053C44.6918 32.5059 45.2096 33.0237 45.2096 33.6625C45.2096 34.3013 44.6918 34.8191 44.053 34.8191H23.1566C22.5178 34.8191 22 34.3013 22 33.6625Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1271 41.1366C42.5755 41.5915 42.5703 42.3238 42.1155 42.7723L40.4657 44.3987C40.0109 44.8472 39.2785 44.842 38.8301 44.3871C38.3816 43.9323 38.3868 43.1999 38.8417 42.7515L40.4914 41.125C40.9463 40.6765 41.6786 40.6817 42.1271 41.1366Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6535 39.157C37.2397 39.157 35.3111 41.0819 35.3111 43.422C35.3111 45.762 37.2397 47.6869 39.6535 47.6869C42.0672 47.6869 43.9959 45.762 43.9959 43.422C43.9959 41.0819 42.0672 39.157 39.6535 39.157ZM32.9978 43.422C32.9978 39.7735 35.9932 36.8438 39.6535 36.8438C43.3138 36.8438 46.3091 39.7735 46.3091 43.422C46.3091 47.0704 43.3138 50.0002 39.6535 50.0002C35.9932 50.0002 32.9978 47.0704 32.9978 43.422Z",
    fill: "#EEEEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iif",
    x: 10.6123,
    y: 14.217,
    width: 46.9939,
    height: 46.2849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.895261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.5,
    dy: -0.895261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect3_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 7.76551,
    y: 0.950565,
    width: 53.1028,
    height: 16.1028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.27569,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 57.3683,
    y: 12.3014,
    width: 10.6472,
    height: 49.1472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.28681,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 0.618284,
    y: 12.3014,
    width: 9.89722,
    height: 49.1472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.28681,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f",
    x: 3.24492,
    y: 8.26738,
    width: 13.6899,
    height: 17.7348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f",
    x: 52.1578,
    y: 8.26738,
    width: 12.6586,
    height: 18.2405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f",
    x: 7.06885,
    y: 12.0908,
    width: 4.37025,
    height: 5.80306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f",
    x: 56.6179,
    y: 12.0908,
    width: 4.37025,
    height: 5.80306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d",
    x: 22,
    y: 26,
    width: 26.3091,
    height: 26.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6875 0 0 0 0 0.6875 0 0 0 0 0.6875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 34.3596,
    y1: 5,
    x2: 34.3596,
    y2: 70.2247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 32.337,
    y1: 14.1011,
    x2: 35.8764,
    y2: 58.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C5C5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSameDayDisabled);
export default __webpack_public_path__ + "static/media/icon_same_day_disabled.92a4873699f6a7b400916a70e1edced0.svg";
export { ForwardRef as ReactComponent };